(() => {
  if (customElements.get('delivery-guidance')) return;
  class DeliveryGuidance extends HTMLElement {
    connectedCallback() {
      this.refresh();
      this.onVisibility = () => { if (!document.hidden) this.refresh(); };
      document.addEventListener('visibilitychange', this.onVisibility);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('visibilitychange', this.onVisibility);
    }
    refresh() {
      clearTimeout(this.timer);
      const source = this.querySelector('[data-delivery-template]');
      const output = this.querySelector('[data-delivery-output]');
      if (!source || !output) return;
      const raw = Number(this.dataset.days);
      const days = Number.isFinite(raw) ? Math.max(0, Math.min(60, Math.floor(raw))) : 5;
      const now = new Date(Date.now());
      const arrival = new Date(now);
      // Local calendar arithmetic stays correct across daylight-saving changes.
      for (let remaining = days; remaining > 0;) {
        arrival.setDate(arrival.getDate() + 1);
        if (this.dataset.dayType !== 'weekdays' || ![0, 6].includes(arrival.getDay())) remaining--;
      }
      const elapsed = Math.round((Date.UTC(arrival.getFullYear(), arrival.getMonth(), arrival.getDate()) - Date.UTC(now.getFullYear(), now.getMonth(), now.getDate())) / 86400000);
      let date, relative;
      try {
        date = new Intl.DateTimeFormat(this.dataset.locale || undefined, { weekday: 'short', day: 'numeric', month: 'short' }).format(arrival);
        relative = new Intl.RelativeTimeFormat(this.dataset.locale || undefined, { numeric: 'auto' }).format(elapsed, 'day');
      } catch {
        date = new Intl.DateTimeFormat('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }).format(arrival);
        relative = new Intl.RelativeTimeFormat('en', { numeric: 'auto' }).format(elapsed, 'day');
      }
      const values = { day: this.dataset.format === 'date' ? date : relative, date, days: String(days) };
      const fragment = source.content.cloneNode(true);
      const walker = document.createTreeWalker(fragment, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      for (const node of nodes) {
        if (!/\{(?:day|date|days)\}/.test(node.textContent)) continue;
        const replacement = document.createDocumentFragment();
        for (const part of node.textContent.split(/(\{(?:day|date|days)\})/)) {
          const key = part.match(/^\{(day|date|days)\}$/)?.[1];
          if (!key) replacement.append(document.createTextNode(part));
          else {
            const span = document.createElement('span');
            span.dataset.deliveryToken = key;
            span.textContent = values[key];
            replacement.append(span);
          }
        }
        node.replaceWith(replacement);
      }
      output.replaceChildren(fragment);
      const midnight = new Date(now);
      midnight.setHours(24, 0, 0, 50);
      this.timer = setTimeout(() => this.refresh(), midnight.getTime() - now.getTime());
    }
  }
  customElements.define('delivery-guidance', DeliveryGuidance);
})();
